import { render, staticRenderFns } from "./detailList.vue?vue&type=template&id=772169d6&scoped=true"
import script from "./detailList.vue?vue&type=script&lang=js"
export * from "./detailList.vue?vue&type=script&lang=js"
import style0 from "./detailList.vue?vue&type=style&index=0&id=772169d6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772169d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/qhygcg-web-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('772169d6')) {
      api.createRecord('772169d6', component.options)
    } else {
      api.reload('772169d6', component.options)
    }
    module.hot.accept("./detailList.vue?vue&type=template&id=772169d6&scoped=true", function () {
      api.rerender('772169d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/projectInfo/components/detailList.vue"
export default component.exports